import React from "react";
import {LayoutContainer} from "./style";
import Header from "../header";
import Footer from "../footer";
const MainLayout = (props) => {
  return (
    <LayoutContainer>
      <Header />
      <main className="main-content">{props.children}</main>
      <Footer />
    </LayoutContainer>
  );
};
export default MainLayout;
